import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import LogoSpinner from '../LogoSpinner/LogoSpinner';

const useStyles = makeStyles(theme => ({
  progress: {

  },
  alignCenter: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  spinnerSize: {
    height: '80px'
  }
}));

const FullpageSpinner = () => {
  const classes = useStyles();
  return (
      <div className={classes.alignCenter}>
        <LogoSpinner className={classes.spinnerSize} />
      </div>
  );
};

export default FullpageSpinner;